import React from 'react';

export default function RecentWorks() {
    return (
        <section id="work" className="bg-black py-24 pb-32 rounded-[50px]">
            <div className="max-w-[1440px] mx-auto px-6 lg:px-20">
                {/* Section Header */}
                <div className="flex flex-col items-center gap-4 mb-20">
                    <span className="text-[#0054DB] font-medium tracking-wider uppercase text-sm">
                        OUR WORKS
                    </span>
                    <h2 className="text-white text-4xl lg:text-5xl font-semibold">
                        Our Recent Works
                    </h2>
                </div>

                {/* Scrollable Container for Mobile / Vertical Stack for Desktop */}
                <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 px-4 pb-8 -mx-6 lg:block lg:space-y-20 lg:overflow-visible lg:px-0 lg:pb-0 lg:mx-0 scrollbar-hide">

                    {/* Featured Project Card 1 - Perform100x */}
                    <div className="w-[calc(100vw-2rem)] sm:min-w-[400px] snap-center shrink-0 lg:w-full lg:min-w-0 lg:sticky lg:top-24 z-10 bg-[#111315] rounded-[32px] p-6 lg:p-12 overflow-hidden border border-white/10 group cursor-pointer hover:border-white/20 transition-all duration-300 shadow-2xl">
                        <div className="grid lg:grid-cols-[400px_1fr] gap-8 lg:gap-20 items-center h-full">

                            {/* Left Content */}
                            <div className="flex flex-col gap-6 lg:gap-8">
                                <h3 className="text-3xl lg:text-5xl font-normal text-white">
                                    Perform100x
                                </h3>
                                <p className="text-gray-400 text-base lg:text-lg leading-relaxed">
                                    We partnered with Perform100x to design and build a modern, high-performing website that clearly communicates their mission of building intelligent growth systems. The experience focuses on clarity, trust, and conversion — helping their audience instantly understand their value and take action.
                                </p>

                                {/* Circular Button */}
                                <a 
                                    href="https://perform100x.com/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="w-12 h-12 lg:w-14 lg:h-14 rounded-full border border-blue-600/50 flex items-center justify-center text-blue-500 group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-600 transition-all duration-300 mt-2 lg:mt-4"
                                >
                                    <svg className="w-5 h-5 lg:w-6 lg:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 19L19 5M19 5H9M19 5V15" />
                                    </svg>
                                </a>
                            </div>

                            {/* Right Visual - Browser Mockup */}
                            <div className="relative w-full aspect-[4/3] lg:aspect-auto lg:h-[500px] bg-white rounded-2xl overflow-hidden shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]">
                                {/* Browser Bar */}
                                <div className="absolute top-0 left-0 w-full h-8 bg-[#f3f4f6] border-b border-gray-200 flex items-center px-4 gap-2 z-10">
                                    <div className="flex gap-1.5">
                                        <div className="w-2.5 h-2.5 rounded-full bg-red-400" />
                                        <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
                                        <div className="w-2.5 h-2.5 rounded-full bg-green-400" />
                                    </div>
                                </div>

                                {/* Website Content Preview */}
                                <div className="w-full h-full pt-8 bg-white relative">
                                    <img
                                        src="/images/perform100x.png"
                                        alt="Perform100x Website"
                                        className="w-full h-full object-cover object-top"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Featured Project Card 2 - Vedam Info */}
                    <div className="w-[calc(100vw-2rem)] sm:min-w-[400px] snap-center shrink-0 lg:w-full lg:min-w-0 lg:sticky lg:top-24 z-20 bg-[#111315] rounded-[32px] p-6 lg:p-12 overflow-hidden border border-white/10 group cursor-pointer hover:border-white/20 transition-all duration-300 shadow-2xl lg:mb-20">
                        <div className="grid lg:grid-cols-[400px_1fr] gap-8 lg:gap-20 items-center h-full">

                            {/* Left Content */}
                            <div className="flex flex-col gap-6 lg:gap-8">
                                <h3 className="text-3xl lg:text-5xl font-normal text-white">
                                    Vedam Info
                                </h3>
                                <p className="text-gray-400 text-base lg:text-lg leading-relaxed">
                                    For Vedam Info, we created a student-friendly online testing platform that makes exam preparation simple, engaging, and effective. The design emphasizes ease of use, performance tracking, and motivation, ensuring students and parents immediately understand the platform's benefits.
                                </p>

                                {/* Circular Button */}
                                <a 
                                    href="https://vedam.info/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="w-12 h-12 lg:w-14 lg:h-14 rounded-full border border-blue-600/50 flex items-center justify-center text-blue-500 group-hover:bg-blue-600 group-hover:text-white group-hover:border-blue-600 transition-all duration-300 mt-2 lg:mt-4"
                                >
                                    <svg className="w-5 h-5 lg:w-6 lg:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 19L19 5M19 5H9M19 5V15" />
                                    </svg>
                                </a>
                            </div>

                            {/* Right Visual - Browser Mockup */}
                            <div className="relative w-full aspect-[4/3] lg:aspect-auto lg:h-[500px] bg-white rounded-2xl overflow-hidden shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]">
                                {/* Browser Bar */}
                                <div className="absolute top-0 left-0 w-full h-8 bg-[#f3f4f6] border-b border-gray-200 flex items-center px-4 gap-2 z-10">
                                    <div className="flex gap-1.5">
                                        <div className="w-2.5 h-2.5 rounded-full bg-red-400" />
                                        <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
                                        <div className="w-2.5 h-2.5 rounded-full bg-green-400" />
                                    </div>
                                </div>

                                {/* Website Content Preview */}
                                <div className="w-full h-full pt-8 relative bg-white">
                                    <img
                                        src="/images/vedam-new.jpg"
                                        alt="Vedam Info Website"
                                        className="w-full h-full object-fill"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Featured Project Card 3 - SkillUniv */}
                    <div className="w-[calc(100vw-2rem)] sm:min-w-[400px] snap-center shrink-0 lg:w-full lg:min-w-0 lg:sticky lg:top-24 z-30 bg-[#111315] rounded-[32px] p-6 lg:p-12 overflow-hidden border border-white/10 group cursor-pointer hover:border-white/20 transition-all duration-300 shadow-2xl">
                        <div className="grid lg:grid-cols-[400px_1fr] gap-8 lg:gap-20 items-center h-full">

                            {/* Left Content */}
                            <div className="flex flex-col gap-6 lg:gap-8">
                                <div className="space-y-4">
                                    <h3 className="text-3xl lg:text-5xl font-normal text-white">
                                        SkillUniv
                                    </h3>
                                    <div className="space-y-4">
                                        <p className="text-[#D4FF00] text-xl lg:text-2xl font-semibold leading-tight">
                                            DEGREES DON'T BUILD CAREERS. <br />
                                            <span className="text-white">Skills do. Outcomes do.</span>
                                        </p>
                                        <p className="text-gray-400 text-base lg:text-lg leading-relaxed">
                                            Skill Univ is leading India's Skill Revolution by building job-ready talent. We focus on real roles, real skills, and real employability.
                                        </p>
                                        <div className="flex flex-wrap gap-2 pt-2">
                                            <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-gray-300">No theory overload</span>
                                            <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-gray-300">No vanity certificates</span>
                                            <div className="w-full sm:w-auto mt-2 sm:mt-0">
                                                <span className="px-4 py-1.5 bg-[#D4FF00]/10 border border-[#D4FF00]/20 rounded-full text-xs font-medium text-[#D4FF00]">
                                                    Only skills that convert into careers
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Circular Button */}
                                <a 
                                    href="https://theskilluniv.com/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="w-12 h-12 lg:w-14 lg:h-14 rounded-full border border-[#D4FF00]/50 flex items-center justify-center text-[#D4FF00] group-hover:bg-[#D4FF00] group-hover:text-black group-hover:border-[#D4FF00] transition-all duration-300 mt-2 lg:mt-4"
                                >
                                    <svg className="w-5 h-5 lg:w-6 lg:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 19L19 5M19 5H9M19 5V15" />
                                    </svg>
                                </a>
                            </div>

                            {/* Right Visual - Browser Mockup */}
                            <div className="relative w-full aspect-[4/3] lg:aspect-auto lg:h-[500px] bg-white rounded-2xl overflow-hidden shadow-2xl transition-transform duration-700 group-hover:scale-[1.02]">
                                {/* Browser Bar */}
                                <div className="absolute top-0 left-0 w-full h-8 bg-[#f3f4f6] border-b border-gray-200 flex items-center px-4 gap-2 z-10">
                                    <div className="flex gap-1.5">
                                        <div className="w-2.5 h-2.5 rounded-full bg-red-400" />
                                        <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" />
                                        <div className="w-2.5 h-2.5 rounded-full bg-green-400" />
                                    </div>
                                </div>

                                {/* Website Content Preview */}
                                <div className="w-full h-full pt-8 bg-[#0a0a0a] relative">
                                    <img
                                        src="/images/skill-univ.png"
                                        alt="SkillUniv Website"
                                        className="w-full h-full object-cover object-top"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}